import { render, staticRenderFns } from "./sub2_b.vue?vue&type=template&id=2b2a78fe&"
import script from "./sub2_b.vue?vue&type=script&lang=js&"
export * from "./sub2_b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports